var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromocode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5816 10.7531L10.7315 0.834357L10.6612 0.764044H10.6424C10.2533 0.393732 9.8032 0.201544 9.24061 0.187482L4.56639 0.0140442L4.3601 0.00466919C3.83502 0.0140442 3.3193 0.215607 2.9208 0.618732L0.614165 2.92029C0.19222 3.34217 0 3.89998 0 4.45311C0 4.45311 0 4.45311 0 4.45779L0.0140648 4.65467L0.32818 9.21561C0.32818 9.22029 0.32818 9.22498 0.32818 9.22498V9.31404C0.375063 9.72186 0.539153 10.125 0.815761 10.4578L1.07362 10.7109L10.7455 20.4984L10.8909 20.6437C11.4488 21.1359 12.2974 21.1125 12.8271 20.5781L20.5816 12.7687C21.1348 12.2156 21.1442 11.3109 20.5816 10.7531ZM5.25107 7.49993C4.00868 7.49993 3.0007 6.49212 3.0007 5.24993C3.0007 4.00774 4.00868 2.99993 5.25107 2.99993C6.49347 2.99993 7.50145 4.00774 7.50145 5.24993C7.50145 6.49212 6.49347 7.49993 5.25107 7.49993Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_214_21794",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5816 10.7531L10.7315 0.834357L10.6612 0.764044H10.6424C10.2533 0.393732 9.8032 0.201544 9.24061 0.187482L4.56639 0.0140442L4.3601 0.00466919C3.83502 0.0140442 3.3193 0.215607 2.9208 0.618732L0.614165 2.92029C0.19222 3.34217 0 3.89998 0 4.45311C0 4.45311 0 4.45311 0 4.45779L0.0140648 4.65467L0.32818 9.21561C0.32818 9.22029 0.32818 9.22498 0.32818 9.22498V9.31404C0.375063 9.72186 0.539153 10.125 0.815761 10.4578L1.07362 10.7109L10.7455 20.4984L10.8909 20.6437C11.4488 21.1359 12.2974 21.1125 12.8271 20.5781L20.5816 12.7687C21.1348 12.2156 21.1442 11.3109 20.5816 10.7531ZM5.25107 7.49993C4.00868 7.49993 3.0007 6.49212 3.0007 5.24993C3.0007 4.00774 4.00868 2.99993 5.25107 2.99993C6.49347 2.99993 7.50145 4.00774 7.50145 5.24993C7.50145 6.49212 6.49347 7.49993 5.25107 7.49993Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_214_21794)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromocode);
export default __webpack_public_path__ + "static/media/promocode.a9648d489a1b08b4d12849cf0b32b938.svg";
export { ForwardRef as ReactComponent };